import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { TaskChecklist } from 'src/app/modules/entry-control/interfaces/tasks';

@Component({
  selector: 'app-edit-task-checklist',
  templateUrl: './edit-task-checklist.component.html',
  styleUrls: ['./edit-task-checklist.component.css']
})
export class EditTaskChecklistComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataId > 0) {
      this.get(this.dataId);
    }
  }
  ngOnInit(): void {
    if (this.dataId > 0) {
      this.get(this.dataId);
    }
  }

  @Input()
  dataId: number = 0;

  @Output()
  success = new EventEmitter<boolean>();

  primaryForm = new UntypedFormGroup({
    label: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    observation: new UntypedFormControl(''),
    email_notification: new UntypedFormControl('', [Validators.email]),
  });

  items: { id?: number; label: string; evidence_required: boolean }[] = [];

  get(id: number) {
    this.api.getTaskChecklist(id).subscribe(
      (response) => {
        const data = response.data as TaskChecklist;
        this.primaryForm.patchValue(data);
        this.items = (data.items || []).map((item) => ({
          id: item.id,
          label: item.label,
          evidence_required: !!item.evidence_required,
        }));
      },
      (error) => {
        this.toast.warning(error.error.mistakes, error.error.msg);
        this.modal.dismissAll();
      }
    );
  }

  addItem() {
    this.items.push({ label: '', evidence_required: false });
  }

  removeItem(index: number) {
    this.items.splice(index, 1);
  }

  update() {
    if (this.primaryForm.invalid) {
      if (this.primaryForm.get('email_notification')?.invalid) {
        this.toast.warning('El correo de notificación ingresado no es válido', 'Tenemos un error');
      } else {
        this.toast.warning('Debe ingresar un nombre válido para la lista (mínimo 3 caracteres)', 'Tenemos un error');
      }
      return;
    }
    const validItems = this.items.filter((i) => i.label && i.label.trim().length >= 2);
    if (validItems.length === 0) {
      this.toast.warning('Debe incluir al menos una tarea en la lista', 'Tenemos un error');
      return;
    }
    const data = {
      label: this.primaryForm.get('label')?.value,
      observation: this.primaryForm.get('observation')?.value,
      email_notification: this.primaryForm.get('email_notification')?.value,
      items: validItems.map((item, index) => ({
        id: item.id,
        label: item.label.trim(),
        position: index,
        evidence_required: item.evidence_required,
      })),
    };
    this.api.updateTaskChecklist(this.dataId, data).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Gestión de tareas');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (error) => {
        this.toast.warning(error.error.mistakes, error.error.msg, {
          enableHtml: true,
          closeButton: true,
        });
      }
    );
  }
}
